import React from 'react';

class IncidentTemplateListItem extends React.Component {
  _editLink() {
    return Routes.edit_page_incident_template_path(
      this.props.pageParam,
      this.props.template.id,
    );
  }

  _handleDelete() {
    if (window.confirm('Are you sure you want to delete this template?')) {
      $.ajax({
        type: 'DELETE',
        url: Routes.page_incident_template_path(
          this.props.pageParam,
          this.props.template.id,
        ),
        dataType: 'JSON',
        success(data, textStatus, xhr) {
          window.location.reload(true);
        },
        error(xhr, textStatus) {
          HRB.utils.basicFailAndReload('deleting an incident template');
        },
      });
    }
  }

  render() {
    const template = this.props.template;

    return (
      <div className="template-item-description">
        <strong>
          <a href={this._editLink()} className="list-view-link">
            {template.name}
          </a>
        </strong>
        <span className="actions">
          <a href="#" method="DELETE" onClick={this._handleDelete.bind(this)}>
            Delete
          </a>
          <a href={this._editLink()}>Edit</a>
        </span>
      </div>
    );
  }
}

export default IncidentTemplateListItem;
